import {SEQUENCE_USED_SOUND} from './LinkTypes.js';
import GetSequences from 'search/GetSequences.js';
import ethereum from 'decentralized/ethereum.js';
import Sequence from 'repos/Sequence.js';

export async function getRootFromLink(linkType) {
    switch(linkType) {
    case SEQUENCE_USED_SOUND:
        console.log("link type was correct");
        let getter = new GetSequences();
        await getter.executeQuery();
        while (await getter.getNext()) {
            console.log("getting next");
        }
        return ethereum.collapseAllSequences(getter.results)
            .map(
                result => new Sequence(undefined, undefined, result.newSequence, undefined, result.title));
    }
}
